import { Box, TypographyProps } from '@mui/material';

import Icon from 'components/@icons/Icon';
import CategoryColor from 'components/@seating/CategoryColor';

interface Props {
  quantity?: number;
  seatColor?: string;
  color?: TypographyProps['color'];
}

const getDigitCount = (quantity: number): number => {
  return quantity.toString().length;
};
const getQuantityFontSize = (quantity: number): string => {
  const digitCount = getDigitCount(quantity);
  if (digitCount <= 1) {
    return '12px';
  }
  if (digitCount === 2) {
    return '11px';
  }
  if (digitCount === 3) {
    return '8px';
  }
  if (digitCount === 4) {
    return '7px';
  }
  return '6px';
};

const TicketQuantityIcon = ({
  quantity,
  seatColor,
  color = 'text.secondary',
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
      }}
    >
      <Icon name="TicketEmpty" fontSize={40} sx={{ color }} />
      {quantity && (
        <Box
          component="span"
          alignItems="center"
          sx={{
            wordBreak: 'normal',
            color,
            position: 'absolute',
            top: 12 + getDigitCount(quantity),
            left: quantity < 10 ? 13 : 10,
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: getQuantityFontSize(quantity),
          }}
        >
          {quantity}x
        </Box>
      )}
      {seatColor && (
        <CategoryColor
          color={seatColor}
          size={16}
          sx={{
            position: 'absolute',
            top: 12,
            left: 12,
          }}
        />
      )}
    </Box>
  );
};

export default TicketQuantityIcon;
